const e = "select", l = "select__label", t = "select__error", s = {
  select: e,
  "select__native-input": "select__native-input",
  "select__native-input-custom-control": "select__native-input-custom-control",
  "select__native-input-custom-control--invalid": "select__native-input-custom-control--invalid",
  "select__native-input-icon": "select__native-input-icon",
  "select__native-input-icon--disabled": "select__native-input-icon--disabled",
  "select__input-wrapper": "select__input-wrapper",
  "select__label-wrapper": "select__label-wrapper",
  "select__input-wrapper--disabled": "select__input-wrapper--disabled",
  "select--disabled": "select--disabled",
  "select--full-width": "select--full-width",
  select__label: l,
  "select__label--disabled": "select__label--disabled",
  "select__item-label": "select__item-label",
  "select__item-label--disabled": "select__item-label--disabled",
  "select__item-label-end": "select__item-label-end",
  "select--size-small": "select--size-small",
  select__error: t,
  "select__error-text": "select__error-text"
};
export {
  s as default,
  e as select,
  t as select__error,
  l as select__label
};
